export default {
    Agencias: axios.create({
        baseURL: process.env.VUE_APP_ENDPOINT_API + "agencias"
    })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/Agencias.js
// module id = JM62
// module chunks = 16